module.exports = __webpack_public_path__ + "static/img/service_introduce_5118_zh_h5.28d97b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5118_zh_h5.png
// module id = WsUY
// module chunks = 34